<template>
    <div class="d-flex flex-1 h-100 overflow-auto delegation">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageReference") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row justify-space-between m-0 gap-2">
                    <div class="p-0" style="width: 18%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Category") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select   class="light-bg add-arrow w-100" v-model="selectedCategory" label="name" track-by="id"
                                open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                            </multi-select>
                        </div>
                    </div>
                    <div class="p-0" style="width: 23%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_SelectCompany") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select   class="light-bg add-arrow w-100" v-model="companyId" label="name" track-by="id"
                                open-direction="bottom" :options="company_items" :searchable="false" 
                                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false" 
                                :placeholder="$t('res_Label_Select')"  @input="handleCompanySelectionChange">
                            </multi-select> 
                        </div>
                    </div>
                    <div class="p-0" style="width: 23%">
                        <label class="label_required mb-1">{{ $t("res_Label_Structure") }}</label>  
                        <multi-select class="light-bg add-arrow w-100" v-model="structureIdVal" label="text" track-by="id"
                                open-direction="bottom" :options="structure_items" :searchable="false" 
                                :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                        </multi-select> 
                    </div>
                    <div class="p-0" style="width: 28%">
                        <label class="label_required mb-1">{{ $t("res_MenuItems_ChooseTemplate") }}</label>
                        <multi-select class="light-bg add-arrow w-100" v-model="templateId" label="name" track-by="id"
                            open-direction="bottom" :options="templates_items" :searchable="true" 
                            :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                            :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                            :placeholder="$t('res_Label_Select')">
                            <template slot="option" slot-scope="props">
                                <div style="height: 50px; width: 100%; display: flex;text-align:start">
                                    <div class="ad__box">
                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                        <p class="ad__text">({{ props.option.structureName }})</p>
                                    </div>
                                </div>
                            </template>
                        </multi-select>
                    </div>
                </div>
                <v-row>
                    <div class="d-flex justify-space-between align-items-center ">
                        <v-checkbox class="m-0" v-model="byPdf" :label="byPdfLabel"></v-checkbox>
                        <div class="d-flex gap-2">
                            <v-btn @click="clear()" width="100px" color="mx-2 light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn @click="displayCategory()" width="100px" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn @click="addDialog = true" width="100px" color="mx-2 primary">{{ $t("res_ButtonText_Add") }}</v-btn>
                        </div>
                    </div>
                </v-row>
                <hr>
                <v-data-table :headers="headers" :items="displayedItems" item-key="id" disable-sort hide-default-footer
                    class="position-relative white flex-1 d-flex overflow-auto"  :items-per-page="displayedItems.length">
                    <template v-slot:item="row">
                        <tr>
                            <td>{{ row.item.type }}</td>
                            <td>{{ row.item.content }}</td>
                            <td>{{ row.item.order }}</td>
                            <td>{{ row.item.byPdf }}</td>
                            <td>{{ row.item.categoryName }} </td>
                            <td>{{ row.item.structureName }} </td>
                            <td>{{ row.item.templateName }} </td>
                            <td>{{ row.item.companyName }} </td>
                            <td class="text-start">
                                <div class="onhover-display">
                                    <div class="custom-icon-wrapper">
                                        <v-icon small @click="dialogEdit(row.item)">custom-icon white-bg edit-icon</v-icon>
                                    </div>
                                    <div class="custom-icon-wrapper">
                                        <v-icon small @click="deleteCategory(row.item)">custom-icon white-bg delete-icon</v-icon>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>

            <v-dialog v-model="addDialog" max-width="800px">
                <v-card>
                    <v-card-title>{{ $t("res_ButtonText_Add") }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-label>{{ $t("res_label_committee_category") }}* </v-label>
                                <multi-select  class="light-bg add-arrow" v-model="addFormDialog.selectedCategory" label="name" track-by="id"
                                    open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.companyId" label="name" track-by="id"
                                    open-direction="bottom" :options="company_items" :searchable="false" 
                                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')" @input="handleCompanyInFormSelectionChange">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Structure") }} </v-label>
                                <multi-select class="light-bg add-arrow w-100" v-model="addFormDialog.structureIdVal" label="text" track-by="id"
                                open-direction="bottom" :options="structure_items_InForm" :searchable="false" 
                                :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                        </multi-select> 
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.templateId" label="name"
                                    track-by="id" open-direction="bottom" :options="templates_items" :searchable="true"
                                     :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                    <template slot="option" slot-scope="props">
                                        <div style="height: 50px; width: 100%; display: flex;text-align:start">
                                            <div class="ad__box">
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">({{ props.option.structureName }})</p>
                                            </div>
                                        </div>
                                    </template>
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_GridHeaders_Type") }}*</v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.type" :options="typeOption" label="name"
                                    track-by="id" 
                                    open-direction="bottom" :searchable="true" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Content") }}*</v-label>
                                <v-text-field v-model="addFormDialog.content" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Order") }}*</v-label>
                                <v-text-field v-model="addFormDialog.order" type="number" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_CheckBox_ByPdf") }}</v-label>
                                <v-checkbox class="m-0" v-model="addFormDialog.byPdf" solo></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="gap-2 sticky-actions" v-bind="row">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" style="min-width: 100px !important" @click="closeDialog()">{{ $t("res_ButtonText_Close") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important" @click="addCategory()">{{ $t("res_ButtonText_Add") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editDialog" max-width="800px">
                <v-card>
                    <v-card-title>{{ $t("res_ButtonText_Edit") }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-label>{{ $t("res_label_committee_category") }} </v-label>
                                <v-select class="w-100" :disabled="true" v-model="editedItem.selectedCategory"
                                    :label="name" :items="this.applicationsOptions" item-text="name" item-value="id" solo>
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.companyId" label="name" track-by="id"
                                    open-direction="bottom" :options="company_items" :searchable="false" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :disabled="true" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Structure") }} </v-label>
                                <StructureUserSelector class=" w-100" :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="true" :showExternalStructures="false" :isMultiple="false"
                                    :selectedStructureUser="editedItem.structureId" :disableOtherInternalEntitiesAsExternal="true"
                                    @structureUserSelectChanged="structureUserSelectChangedAdd" :disabled="true"
                                    :addressBook_header="$t('res_Label_SelectStrucutre')">
                                </StructureUserSelector>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.templateId" label="name" track-by="id"
                                    open-direction="bottom" :options="templates_items" :searchable="false" 
                                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :disabled="true" :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                    <template slot="option" slot-scope="props">
                                        <div style="height: 50px; width: 100%; display: flex;text-align:start">
                                            <div class="ad__box">
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">({{ props.option.structureName }})</p>
                                            </div>
                                        </div>
                                    </template>
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_GridHeaders_Type") }}*</v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.type" :options="typeOption" 
                                    label="name" track-by="id" 
                                    open-direction="bottom" :searchable="true" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                </multi-select>                         </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Content") }}*</v-label>
                                <v-text-field v-model="editedItem.content" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Order") }}*</v-label>
                                <v-text-field v-model="editedItem.order" type="number" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_CheckBox_ByPdf") }}</v-label>
                                <v-checkbox class="m-0" :disabled="true" v-model="editedItem.byPdf" solo></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="gap-2 sticky-actions" v-bind="row">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" style="min-width: 100px !important" @click="editDialog = false">{{ $t("res_ButtonText_Close") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important" @click="UpdateCategory()">{{ $t("res_ButtonText_Update") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import constants from "@/assets/js/constants.js";
    import router from "../../router/index.js";
    import MultiSelect from 'vue-multiselect';
    import StructureUserSelector from '@/components/StructureUserSelector.vue';

    export default {
        components: { MultiSelect, StructureUserSelector },
        data() {
            return {
                language: '',
                headers: [
                    { text: this.$t("res_GridHeaders_Type"), value: "type", align: "start", width: "12%" },
                    { text: this.$t("res_GridHeaders_Content"), value: "content", align: "start", width: "12%" },
                    { text: this.$t("res_GridHeaders_Order"), value: "order", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeaders_ByPdf"), value: "bypdf", align: "start", width: "6%" },
                    { text: this.$t("res_label_committee_category"), value: "categoryName", align: "start", width: "13%" },
                    { text: this.$t("res_Label_Structure"), value: "structureName", align: "start", width: "14%" },
                    { text: this.$t("res_Label_TemplateName"), value: "templateName", align: "start", width: "13%" },
                    { text: this.$t("res_label_Company"), value: "companyName", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeaders_Actions"), value: "Action", align: "start", width: "10%" },
                ],
                typeOption: [{ id: 1, name: "String" }, { id: 2, name: "Year" }, { id: 3, name: "Counter" }, { id: 4, name: "Code" }],
                selectedCategory: null,
                displayedItems: [],
                applicationsOptions: [],
                editDialog: false,
                addDialog: false,
                editedItem: {
                    id: 0,
                    type: "",
                    content: "",
                    order: 0,
                    byPdf: false,
                    companyId: {},
                    templateId: {},
                    selectedCategory: null,
                    structureId: null
                },
                addFormDialog: {
                    id: 0,
                    type: "",
                    content: "",
                    order: 0,
                    categoryId: 0,
                    structureIdVal: { id: 0, name: '' },
                    companyId: {},
                    templateId: {},
                    byPdf: false,
                    selectedCategory: null
                },
                company_items: [],
                structure_items: [],
                structure_items_InForm: [],
                structureIdVal: null,
                templates_items: [],
                structureId: { id: 0, isUser: false, name: '' },
                companyId: null,
                templateId: null,
                byPdf: false,
                byPdfLabel: '',
            };
        },
        methods: {
            backToAdminPage() {
                router.push({ name: "admin" });
            },
            structureUserSelectChanged(selectedItem) {
                if (selectedItem) {
                    this.toUser = selectedItem;
                } else {
                    this.toUser = { id: 0, name: "" }
                }
            },
            structureUserSelectChangedAdd(selectedItem) {
                if (selectedItem) {
                    this.addFormDialog.structureId = selectedItem;
                } else {
                    this.addFormDialog.structureId = { id: 0, name: "" }
                }
            },
            closeDialog() {
                this.addDialog = false;
                this.resetDataForm();
            },
            dialogEdit(item) {
                this.editedItem = {
                    id: item.id,
                    type: this.typeOption.find(x => x.name == item.type),
                    content: item.content,
                    byPdf: item.byPdf,
                    order: item.order,
                    templateId: this.templates_items.find(x => x.id == item.templateId),
                    companyId: this.company_items.find(x => x.id == item.companyId),
                    selectedCategory: this.applicationsOptions.find(x => x.id == item.categoryId),
                    structureId : item.structures
                }
                this.editDialog = true;
            },
            getCompaniesForUser() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
                    .then((res) => this.company_items = res.data)
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            }, 
            searchStructuresForCompany(searchTerm = '') { 
                window.showLoading() 
                axios.get(constants.baseApiUrl + `Admin/GetStructurePerCompany?companyId=${(this.companyId == null ? 0 : this.companyId.id)}&searchTerm=${searchTerm}`)
                    .then((res) =>this.$nextTick(function () {this.structure_items = res.data;}) )
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },  
            searchStructuresForCompanyInForm(searchTerm = '') {  
                window.showLoading() 
                axios.get(constants.baseApiUrl + `Admin/GetStructurePerCompany?companyId=${(this.addFormDialog.companyId == null ? 0 : this.addFormDialog.companyId.id)}&searchTerm=${searchTerm}`)
                    .then((res) =>this.$nextTick(function () {this.structure_items_InForm = res.data;}) )
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            }, 
            handleCompanySelectionChange()
            {  
                this.searchStructuresForCompany();
            },
            handleCompanyInFormSelectionChange()
            {  
                this.searchStructuresForCompanyInForm();
            },
            getAllTemplates() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetAllTemplates")
                    .then((res) => this.templates_items = res.data)
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            fetchData() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetAllCategory")
                    .then(response => 
                    {
                        const responseData = response.data;
                        if(this.language == 'en') {
                            for (let i = 0; i < responseData.length; i++) {
                                const category = { id: responseData[i].id,  name: responseData[i].name };
                                this.applicationsOptions.push(category);
                            }
                        } else {
                            for (let i = 0; i < responseData.length; i++) {
                                const category = { id: responseData[i].id,  name: responseData[i].nameAr };
                                this.applicationsOptions.push(category);
                            }
                        }

                    }) 
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());   
            },
            GetReferenceCategories(){
             window.showLoading()
             axios.get(`${constants.baseApiUrl}Admin/GetReferenceCategories`)
             .then((res)=>{
               this.displayedItems = res.data;
             }).catch((error)=>{
                console.warn(error)
                window.hideLoading()
             }).finally(() => window.hideLoading());
            },       
             displayCategory() 
            {
                window.showLoading()
                axios.post(
                    constants.baseApiUrl + 'Admin/GetCategoryById', {
                    CategoryId: this.selectedCategory == null ? null : this.selectedCategory.id,
                    CompanyId: this.companyId == null ? null : this.companyId.id,
                    StructureId: this.structureIdVal == null ? null : this.structureIdVal.id,
                    TemplateId: this.templateId == null ? null : this.templateId.id,
                    ByPdf: this.byPdf }, { headers: constants.headers }
                )
                .then((res) => 
                {
                    this.displayedItems = res.data;
                })
                .catch((error) => console.error("Error fetching data:", error))
                .finally(() => window.hideLoading());
            },
            resetDataForm() {
                this.addFormDialog.type = null;
                this.addFormDialog.order = 0;
                this.addFormDialog.content = null;
                this.addFormDialog.companyId = null;
                this.addFormDialog.byPdf = false;
                this.addFormDialog.templateId = null;
                this.addFormDialog.structureIdVal = null;
                this.addFormDialog.selectedCategory = null;
            },
            clear() {
                this.selectedCategory = null;
                this.structureIdVal = { id: 0, text: '' };
                this.companyId = null;
                this.templateId = null;
                this.byPdf = false;
                console.log("cleared");
                this.GetReferenceCategories();
            },
            addCategory() {
                if (this.addFormDialog.selectedCategory == null || this.addFormDialog.type == '' || this.addFormDialog.order == null || this.addFormDialog.content == '') {
                    return window.showAlert('res_Msgs_FillRequired', 'error')
                }

                var addNewCategory = {
                    CategoryId: this.addFormDialog.selectedCategory.id,
                    Type: this.addFormDialog.type.name,
                    Order: this.addFormDialog.order,
                    Content: this.addFormDialog.content,
                    CompanyId: this.addFormDialog.companyId == null ? null : this.addFormDialog.companyId.id,
                    TemplateId: this.addFormDialog.templateId == null ? null : this.addFormDialog.templateId.id,
                    StructureId: this.addFormDialog.structureIdVal == null ||(this.addFormDialog.structureIdVal != null && this.addFormDialog.structureIdVal.id=== 0) ? null : this.addFormDialog.structureIdVal.id,
                    ByPdf: this.addFormDialog.byPdf
                };

                window.showLoading()
                axios.post(constants.baseApiUrl + "Admin/AddNewreferenceNumber", addNewCategory)
                    .then((res) => 
                    {
                        if (res == undefined || res.data == null)
                            window.showAlert("res_Msgs_ErrorOccured", "error");
                        else 
                        {
                            this.addDialog = false
                            this.GetReferenceCategories()
                            this.resetDataForm()
                            window.showAlert("res_Msgs_AddFormatCounter", "success")
                        }
                    })
                    .catch((err) => {
                        this.handleError(err);
                        window.hideLoading();
                    })
                    .finally(() => window.hideLoading());
            },
            deleteCategory(item) {
                window.showInformation(
                    "Confirmation",
                    "res_Msgs_CategoryreferenceDeleteConfirmation",
                    () => {
                    axios.delete(constants.baseApiUrl + "Admin/DeleteCategoryNumber/" + item.id)
                        .then((res) => {
                            window.showAlert("res_Msgs_FormatCountDeleted", "success");
                            this.GetReferenceCategories();
                        })
                        .catch((err) => console.log(err));
                    },
                    () => { }
                );
            },
            UpdateCategory() {
                var editReference = {
                    Type: this.editedItem.type.name,
                    Order: this.editedItem.order, 
                    Content: this.editedItem.content,
                    ByPdf: this.editedItem.byPdf,
                    CompanyId: this.editedItem.companyId == null ? null : this.editedItem.companyId.id,
                    TemplateId: this.editedItem.templateId == null ? null : this.editedItem.templateId.id,
                    StructureId: this.editedItem.structureId == null ? null : this.editedItem.structureId.id,
                    CategoryId: this.editedItem.selectedCategory.id,
                };

                window.showLoading()
                axios.put(constants.baseApiUrl + "Admin/UpdateCategoryNumber/" + this.editedItem.id, editReference)
                    .then((res) => 
                    {
                        if (res == undefined || res.data == null) 
                        {
                            window.showAlert("res_Msgs_ErrorOccured", "error");
                        } 
                        else 
                        {
                            window.showAlert("res_Msgs_FormatCountUpdated", "success");
                            this.editDialog = false;
                            this.GetReferenceCategories();
                        }
                    })
                    .catch((err) => {
                        this.handleError(err);
                        window.hideLoading();
                    })
                    .finally(() => window.hideLoading());
            }
        },
        mounted() {
            this.GetReferenceCategories();
            this.getCompaniesForUser(); 
            this.searchStructuresForCompany('');
            this.getAllTemplates();
            this.fetchData();
            this.language = localStorage.getItem('lang');
            this.byPdfLabel = window.translate("res_CheckBox_ByPdf");
        },
    };
</script>